import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { MoveDirectionEnum } from '@/services/models/Enums';
import ConstantsHelperMixin from './constants-helper-mixin';

export interface SwapIndexes {
  a: number;
  b: number;
}

@Component
export default class BasicHelperMixin extends mixins(ConstantsHelperMixin) {
  getRebuildedList(list: any[]) {
      let nullElem: any = [
        {
          domain: this.t('Account default'),
          id: '',
          direct: false
        }
      ];

      return [
        ...nullElem.concat(list)
      ];
  }

  canMoveUp(index: number) {
    //we cant move default rule on index 0, neither first rule  
    return index > 1;
  }

  canMoveDown(index: number, items: any) {
    return index < items.length - 1;
  }

  canMoveDownAlt(index: number, length: number) {
    return index < length - 1;
  }

  getSwapIndexes(index: number, items: any[], direction: MoveDirectionEnum = MoveDirectionEnum.up): SwapIndexes {
    let swapIndex1: number;
    let swapIndex2: number;

    switch(direction) {
      case MoveDirectionEnum.up: //up
        if(!this.canMoveUp(index)) { 
          return;
        }
        
        swapIndex1 = index - 1;
        swapIndex2 = index;
        break;
      case MoveDirectionEnum.down:
        if(!this.canMoveDown(index, items)) {
          return;
        }

        swapIndex1 = index;
        swapIndex2 = index + 1;
        break;
      
      default: 
        return;
    }

    return {
      a: swapIndex1,
      b: swapIndex2,
    }
  }

  swap(items: any[], ids: SwapIndexes) {
    let temp = items[ids.a];
    this.$set(items, ids.a, items[ids.b]);
    this.$set(items, ids.b, temp);
  }

  moveRule(index: number, items: any[], direction: MoveDirectionEnum = MoveDirectionEnum.up) {
    const ids = this.getSwapIndexes(index, items, direction);

    if (ids) {
      this.swap(items, ids);
    }
  }
}
